import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "monthYear",
    "period",
    "calendarType",
    "dayCheckbox",
    "summaryText",
    "hiddenCalendarType",
    "hiddenDates",
    "hiddenDeleteDates",
    "existingDates"
  ]

  connect() {
    this.calculate()
  }

  calculate() {
    const [year, month] = this.monthYearTarget.value
      .split("-")
      .map(Number)

    const period = this.periodTarget.value

    const selectedDays = this.dayCheckboxTargets
      .filter(cb => cb.checked)
      .map(cb => parseInt(cb.value, 10))

    const dayNames = {
      0: "日",
      1: "月",
      2: "火",
      3: "水",
      4: "木",
      5: "金",
      6: "土"
    }

    const monthNames = {
      1: "Jan",
      2: "Feb",
      3: "Mar",
      4: "Apr",
      5: "May",
      6: "Jun",
      7: "Jul",
      8: "Aug",
      9: "Sep",
      10: "Oct",
      11: "Nov",
      12: "Dec"
    }

    const selectedDayNames = selectedDays.map(d => dayNames[d]).join("・")

    const dates = []

    if (selectedDays.length > 0) {
      let currentDate, endDate
      if (period === "year") {
        currentDate = new Date(year, 0, 1)
        endDate = new Date(year + 1, 0, 1)
      } else {
        currentDate = new Date(year, month - 1, 1)
        endDate = new Date(year, month, 1)
      }

      while (currentDate < endDate) {
        // JavaScript getDay() returns 0 for Sunday, 1 for Monday...
        const mappedDay = currentDate.getDay()

        if (selectedDays.includes(mappedDay)) {
          // Format as YYYY-MM-DD
          const formattedDate = new Date(currentDate.getTime() - (currentDate.getTimezoneOffset() * 60000)).toISOString().split('T')[0]
          dates.push(formattedDate)
        }
        
        currentDate.setDate(currentDate.getDate() + 1)
      }
    }

    this.generatedDates = dates

    const periodText = period === "year" ? `${year}年` : `${year}年${month}月`

    if (dates.length > 0) {
      this.summaryTextTarget.textContent = `${periodText}の${selectedDayNames}を自動生成します。（合計: ${dates.length}日）`
    } else {
      this.summaryTextTarget.textContent = `${periodText}に生成する曜日を選択してください。`
    }
  }

  submit(event) {
    if (!this.generatedDates || this.generatedDates.length === 0) {
      event.preventDefault()
      alert("生成する曜日を1つ以上選択してください。")
      return
    }

    if (!this.calendarTypeTarget.value.trim()) {
      event.preventDefault()
      alert("祝日名を入力してください。")
      return
    }

    this.hiddenCalendarTypeTarget.value = this.calendarTypeTarget.value
    this.hiddenDatesTarget.value = JSON.stringify(this.generatedDates)
  }

  submitDelete(event) {
    if (!this.generatedDates || this.generatedDates.length === 0) {
      event.preventDefault()
      alert("削除する曜日を1つ以上選択してください。")
      return
    }

    // Only delete dates that actually have a holiday, so the count reflects
    // existing holidays instead of every matching weekday in the period.
    const existing = this.existingHolidayDates()
    const datesToDelete = this.generatedDates.filter(date => existing.has(date))

    if (datesToDelete.length === 0) {
      event.preventDefault()
      alert("選択した曜日に該当する公休日がありません。")
      return
    }

    if (!confirm(`選択した曜日の公休日${datesToDelete.length}件を削除します。よろしいですか？`)) {
      event.preventDefault()
      return
    }

    this.hiddenDeleteDatesTarget.value = JSON.stringify(datesToDelete)
  }

  existingHolidayDates() {
    if (!this.hasExistingDatesTarget) return new Set()

    try {
      return new Set(JSON.parse(this.existingDatesTarget.dataset.dates || "[]"))
    } catch {
      return new Set()
    }
  }
}
